enum InventoryTypeId {
  Core = 1,
  WIP = 2,
  ThirdParty = 3,
  DealerMarketplace = 4
}

enum InventoryTypeKey {
  Core = 'Core',
  WIP = 'WIP',
  ThirdParty = 'ThirdParty',
  DealerMarketplace = 'DealerMarketplace'
}

export { InventoryTypeId, InventoryTypeKey };
